var ltCart = document.querySelector('.lt-cart')
var nav = document.querySelector("header.lt-main-nav");
var headerIcon = document.querySelector('.header__icon')
var logoImg = document.querySelector('.lt-logo')
var mobileMenu = document.querySelector('.fa-bars')

if (window.location.pathname !== "/") {
  ltCart.style.setProperty("fill", "#101010");
  headerIcon.style.setProperty("fill", "#101010");
    nav.style.background = '#fff';
    nav.style.color = '#101010';
    logoImg.style.filter = 'initial';
} else {
  ltCart.style.setProperty("fill", "#fff");
  headerIcon.style.setProperty("fill", "#fff");
}

document.addEventListener('DOMContentLoaded', function() {
    const coaAccordionBtns = document.querySelectorAll(".cert-cannabis-accordion");

    if (coaAccordionBtns.length > 0) {
        // Add onclick event to each accordion button
        coaAccordionBtns.forEach((accordion) => {
            accordion.onclick = function () {
                this.classList.toggle("is-open");

                let content = this.nextElementSibling;

                if (content.style.maxHeight) {
                    // Close the accordion
                    content.style.maxHeight = null;
                } else {
                    // Open the accordion
                    content.style.maxHeight = 'none'; // Set maxHeight to scrollHeight for animation
                }
            };
        });

        // Automatically click the first accordion button to open it
        // coaAccordionBtns[0].click();

        // Function to recalculate maxHeight on resize
        function recalculateHeights() {
            coaAccordionBtns.forEach((accordion) => {
                let content = accordion.nextElementSibling;
                if (accordion.classList.contains("is-open")) {
                    content.style.maxHeight = 'none'; // Recalculate height for open accordion
                }
            });
        }

        // Add resize event listener
        window.addEventListener('resize', recalculateHeights);
    }
});

// Get the current URL
const currentUrl = window.location.href;

// Function to hide elements dynamically
function hideElements() {
  console.log("Running hideElements...");

  // Hide all elements with the class 'needsclick'
  document.querySelectorAll('.needsclick').forEach(element => {
    element.style.display = 'none';
  });

  // Hide header and footer
  document.querySelectorAll('header, footer').forEach(element => {
    element.style.display = 'none';
  });

  // Hide access-widget-ui
  document.querySelectorAll('access-widget-ui').forEach(element => {
    element.style.display = 'none';
  });

  // Remove all accessiBe accessibility buttons
  document.querySelectorAll('[part="acsb-trigger"]').forEach(button => {
    button.remove();
  });

  // Hide accessiBe elements inside Shadow DOM
  document.querySelectorAll('*').forEach(el => {
    if (el.shadowRoot) {
      let shadowStyle = document.createElement('style');
      shadowStyle.innerHTML = `[part="acsb-trigger"] { display: none !important; }`;
      el.shadowRoot.appendChild(shadowStyle);
    }
  });
}

// Only run if on the 'sales-representative' page
if (currentUrl.includes('sales-representative')) {
  // Run function immediately
  hideElements();

  // Observe the DOM for dynamically injected elements
  const observer = new MutationObserver(() => {
    hideElements();
  });

  // Ensure the observer only runs once
  if (!window.hasRunObserver) {
    observer.observe(document.body, { childList: true, subtree: true });
    window.hasRunObserver = true;
  }
}





